import {CONSULTANT_INDUSTRIES} from '../../../core/entities/company/constants';

type Props = {
  industryCategoryId: number;
  industryCategoryName: string;
  industryId?: number;
};

type ConvertedCompanyIndustryCategory = {
  industryCategoryId: number;
  industryCategoryName: string;
  industryIds: number[];
};

export function convertCompanyIndustryCategory({
  industryCategoryId,
  industryCategoryName,
  industryId,
}: Props): ConvertedCompanyIndustryCategory {
  if (industryCategoryId > 1) {
    return {
      industryCategoryId,
      industryCategoryName,
      industryIds: [],
    };
  }

  // コンサル・シンクタンクは、CONSULTANT_INDSUTRIESに定義されている業界カテゴリーに変換する
  const consultantIndustry = CONSULTANT_INDUSTRIES.find((industry) =>
    industryId ? industry.ids.includes(industryId) : false,
  );
  return {
    industryCategoryId: 1,
    industryCategoryName: consultantIndustry?.name ?? '',
    industryIds: consultantIndustry?.ids ?? [],
  };
}
